<template>
  <div
    class="netpa-list-page-view-toggle"
    dir="rtl"
    role="group"
    :aria-label="ariaLabel"
  >
    <button
      type="button"
      class="netpa-list-page-view-toggle__btn"
      :class="{ 'netpa-list-page-view-toggle__btn--active': value }"
      :aria-pressed="value ? 'true' : 'false'"
      title="ستونی"
      aria-label="ستونی"
      @click="$emit('input', true)"
    >
      <i class="fas fa-columns" aria-hidden="true"></i>
    </button>
    <button
      v-if="showList"
      type="button"
      class="netpa-list-page-view-toggle__btn"
      :class="{ 'netpa-list-page-view-toggle__btn--active': !value }"
      :aria-pressed="!value ? 'true' : 'false'"
      title="ردیفی"
      aria-label="ردیفی"
      @click="$emit('input', false)"
    >
      <i class="fas fa-list" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "NetPaViewToggle",
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    showList: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: "نوع نمایش",
    },
  },
};
</script>
